import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import clsx from 'clsx'

import { ToolActivity } from './components'
import LoadingMessage from '../LoadingMessage'

import useStyles from './styles'
import theme from 'theme'

const ChatMessage = ({
  role = 'human',
  content = '',
  streaming = false,
  phase = null,
  activeToolName = null,
  completedTools = [],
}) => {
  const classes = useStyles()

  if (streaming && phase === 'thinking' && !content) {
    return <LoadingMessage />
  }

  if (role === 'human') {
    return (
      <Box className={classes.chatMessageHuman}>
        <Typography
          variant="body1"
          className={clsx(
            classes.chatMessageText,
            classes.chatMessageHumanText,
          )}
        >
          {content}
        </Typography>
      </Box>
    )
  }

  return (
    <Box display="flex" gridGap={theme.spacing(1)}>
      <Box className={clsx(classes.chatMessageAI, classes.chatMessageText)}>
        <ToolActivity
          completedTools={completedTools}
          phase={phase}
          activeToolName={activeToolName}
          streaming={streaming}
        />

        {content && (
          <Markdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ href, children }) => (
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              ),
            }}
          >
            {content}
          </Markdown>
        )}
      </Box>
    </Box>
  )
}

export default ChatMessage
